import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import {
  DEFAULT_USER_AUTHENTICATED_PAGE,
  EXTERNAL_PASSPORT_APP_DOMAINS,
  HOME,
  USER_SESSION_API_PATH,
} from '../config/navigationalRoutes';
import window from '../utils/window';

// When a user signs in a particular browser, his default page should be
// profile page as long as his session is valid. Hence on the very first page load, calling user api
// '/user' api returns {redirected=FALSE} if user session is valid.
// '/user' api return {redirected=TRUE} if session expired/invalid/null.

export function useUserSession() {
  const [isUserSessionLoading, setUserSessionLoading] = React.useState(true);
  const history = useHistory();
  useEffect(() => {
    const USER_API_ENDPOINT = window.location.origin + USER_SESSION_API_PATH;
    const isExternalSite = EXTERNAL_PASSPORT_APP_DOMAINS.some((domainName) => window.location.href.includes(domainName));

    if (window.location.pathname !== HOME || !isExternalSite) {
      setUserSessionLoading(false);
      return;
    }
    window
      .fetch(USER_API_ENDPOINT)
      .then((res) => {
        // pushing to the default profile page as session is valid
        if (res.ok && !res.redirected) {
          history.push(DEFAULT_USER_AUTHENTICATED_PAGE);
        }
      })
      .finally(() => {
        setUserSessionLoading(false);
      });
  }, [history]);
  return { isUserSessionLoading };
}

export default useUserSession;
